module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921031149_T.ceea8be5.jpg";